import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed, signal } from "@preact/signals"
import { isArray } from "lodash"
import UserInfo from "./userInfo"

const isToggle = signal<boolean>(false)
const isLoading = signal<boolean>(false)

const fetchFav = async () => {
    isLoading.value = true
    await ApiSignalFetchers.fetchDataSignalGameFavList({
        page: 1,
        page_size: 1000,
    })
    isLoading.value = false
}

const _addFav = (id: string) => {
    return ApiSignalFetchers.fetchDataSignalAddGameFav({
        id,
    })
}

const _delFav = (id: string) => {
    return ApiSignalFetchers.fetchDataSignalDeleteGameFav({ id })
}

const favList = computed(() => {
    return isArray(ApiSignals.dataSignalGameFavList.value?.data)
        ? ApiSignals.dataSignalGameFavList.value.data
        : []
})

const favMap = computed(() => {
    return new Map<string | number | undefined, GameApiTypes.Fetcher.Result.GameBetList>(
        favList.value.map((favItem: GameApiTypes.Fetcher.Result.GameBetList) => [
            favItem.id,
            favItem,
        ]),
    )
})

const toggleFav = async (id: string) => {
    if (!UserInfo.isLogin.value) {
        return
    }
    if (isToggle.value) {
        return
    }
    isToggle.value = true
    try {
        if (favMap.value.get(id)) {
            await _delFav(id)
        } else {
            await _addFav(id)
        }
        await fetchFav()
    } finally {
        isToggle.value = false
    }
}

const clearFav = () => {
    ApiSignals.dataSignalGameFavList.value = {
        data: [],
        s: 0,
        t: 0,
    }
}

export const Favorite = {
    clearFav,
    favList,
    favMap,
    fetchFav,
    isLoading,
    isToggle,
    toggleFav,
}
